import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeFromCart, clearCart } from '../../redux/cartSlice';
import { PaystackButton } from 'react-paystack';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/ui/tabs';
import StatCard from './_components/StatCard';
import { Link } from 'react-router-dom';
import Footer from 'components/layouts/Footer';
import { Icon } from '@iconify/react';
import Container from 'components/layouts/Container';
import Header from 'components/layouts/Header';
import Erazer from "../../assets/images/erazer.jpeg"

const Store = () => {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const { items, totalQuantity, totalAmount } = useSelector((state) => state.cart);
    const dispatch = useDispatch();

    // Fallback to a dummy key if the env variable is not found
    const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;

    const config = {
        reference: (new Date()).getTime().toString(),
        email: "user@example.com", // Dummy email for demo
        amount: totalAmount > 0 ? totalAmount * 100 : 100, // Paystack amount is in kobo, must be > 0
        publicKey
    };



    const handlePaystackSuccessAction = (reference) => {
        alert("Payment complete! Reference: " + reference.reference);
        dispatch(clearCart());
        setIsCartOpen(false);
    };

    const handlePaystackCloseAction = () => {
        console.log('Payment closed');
    };

    const componentProps = {
        ...config,
        text: 'Checkout with Paystack',
        onSuccess: (reference) => handlePaystackSuccessAction(reference),
        onClose: handlePaystackCloseAction,
    };

    return (
        <div>
            <Container>
                <Header title="BeeC00des" showNav={false} />
            </Container>


            <div className="text-foreground bg-background p-6 md:p-12 font-mono">
                <div className="max-w-6xl mx-auto">
                    <div className='flex justify-between'>
                        <Link to="/">
                            <h1 className="text-3xl font-bold mb-8 text-[#199C16]">Store</h1>
                        </Link>

                        <div className="flex gap-4">
                            <div>
                                <button
                                    onClick={() => setIsCartOpen(true)}
                                    className="relative flex items-center gap-2 border border-[#199C16] px-5 py-2 w-fit text-xs font-semibold tracking-wider hover:bg-[#199C16] hover:text-white transition-all"
                                >
                                    <Icon icon="mdi:cart" width="18" /> CART

                                    {totalQuantity > 0 && (
                                        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-bold">
                                            {totalQuantity}
                                        </span>
                                    )}
                                </button>
                            </div>


                            <Link to="/">
                                <button
                                    className="flex items-center gap-2 border border-[#199C16] px-5 py-2 w-fit text-xs font-semibold tracking-wider hover:bg-[#199C16] hover:text-white transition-all"
                                >
                                    <Icon icon="mdi:chevron-double-left" width="18" /> BACK TO HOME
                                </button>
                            </Link>
                        </div>
                    </div>

                    <Tabs defaultValue="stationary" className="flex flex-col md:flex-row gap-6 md:gap-10">
                        <TabsList className="flex flex-row md:flex-col w-full md:w-[200px] md:h-[600px] h-fit lg:h-fit lg:bg-card border border-border mb-6 md:mb-10 p-2 gap-2 md:gap-1 overflow-x-auto scrollbar-none">
                            <TabsTrigger
                                value="stationary"
                                className="flex-shrink-0 md:w-full justify-center md:justify-start whitespace-nowrap px-4 py-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-card-muted data-[state=active]:bg-[#199C16] data-[state=active]:text-white data-[state=active]:font-semibold transition-all"
                            >
                                Stationary
                            </TabsTrigger>
                            <TabsTrigger
                                value="swags"
                                className="flex-shrink-0 md:w-full justify-center md:justify-start whitespace-nowrap px-4 py-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-card-muted data-[state=active]:bg-[#199C16] data-[state=active]:text-white data-[state=active]:font-semibold transition-all"
                            >
                                Swags
                            </TabsTrigger>
                            <TabsTrigger
                                value="template"
                                className="flex-shrink-0 md:w-full justify-center md:justify-start whitespace-nowrap px-4 py-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-card-muted data-[state=active]:bg-[#199C16] data-[state=active]:text-white data-[state=active]:font-semibold transition-all"
                            >
                                Template
                            </TabsTrigger>
                            <TabsTrigger
                                value="books"
                                className="flex-shrink-0 md:w-full justify-center md:justify-start whitespace-nowrap px-4 py-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-card-muted data-[state=active]:bg-[#199C16] data-[state=active]:text-white data-[state=active]:font-semibold transition-all"
                            >
                                Books
                            </TabsTrigger>
                        </TabsList>


                        <TabsContent value="stationary" className="space-y-12 animate-in fade-in duration-500 mb-20">
                            <section>
                                <h2 className="text-[#199C16] text-xl font-bold mb-6  tracking-wider">Stationary</h2>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                                    <StatCard id="tech-cards-1" title="Tech educative cards" price={10000} value="₦10,000" image={Erazer} color="#FACC15" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>
                            </section>


                        </TabsContent>

                        <TabsContent value="swags" className="space-y-12 animate-in fade-in duration-500 mb-20">
                            <section>
                                <h2 className="text-[#199C16] text-xl font-bold mb-6  tracking-wider">Swag</h2>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>
                            </section>

                        </TabsContent>
                        <TabsContent value="template" className="space-y-12 animate-in fade-in duration-500 mb-20">
                            <section>
                                <h2 className="text-[#199C16] text-xl font-bold mb-6  tracking-wider">Template</h2>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>
                            </section>
                        </TabsContent>
                        <TabsContent value="books" className="space-y-12 animate-in fade-in duration-500">
                            <section>
                                <h2 className="text-[#199C16] text-xl font-bold mb-6  tracking-wider">Books</h2>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-10">
                                    <StatCard title="Recreation" value="₦12,822" price={12822} icon="mdi:microphone" color="#EF4444" />
                                    <StatCard title="Social" value="₦3,241,445" price={3241445} icon="mdi:chat-processing" color="#10B981" />
                                    <StatCard title="Education" value="₦242,425" price={242425} icon="mdi:book-open-page-variant" color="#3B82F6" />
                                    <StatCard title="Photograph" value="₦757,546" price={757546} icon="mdi:camera" color="#EAB308" />
                                </div>
                            </section>
                        </TabsContent>
                    </Tabs>
                </div>


                <div className="-mt-20">
                    <Footer />
                </div>

            </div>

            {/* Cart Sidebar */}
            {isCartOpen && (
                <div className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-60 backdrop-blur-sm transition-all duration-300">
                    <div className="w-full max-w-md bg-background h-full shadow-2xl border-l border-border flex flex-col animate-in slide-in-from-right duration-300">
                        <div className="flex items-center justify-between p-6 border-b border-border">
                            <h2 className="text-2xl font-bold text-foreground flex items-center gap-3">
                                <Icon icon="mdi:cart-outline" className="text-[#199C16]" /> Your Cart
                            </h2>
                            <div className="flex items-center gap-4">
                                {items.length > 0 && (
                                    <button
                                        onClick={() => dispatch(clearCart())}
                                        className="text-red-500 hover:text-red-400 flex items-center gap-1 text-sm font-semibold transition-colors cursor-pointer border border-red-500/30 px-3 py-1.5 rounded-full hover:bg-red-500/10"
                                    >
                                        <Icon icon="mdi:delete-sweep-outline" width="18" /> Clear All
                                    </button>
                                )}
                                <button onClick={() => setIsCartOpen(false)} className="text-muted-foreground hover:text-foreground bg-card p-2 rounded-full transition-colors cursor-pointer">
                                    <Icon icon="mdi:close" width="24" />
                                </button>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto p-6 space-y-4 scrollbar-none">
                            {items.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-full text-muted-foreground">
                                    <Icon icon="mdi:cart-remove" width="64" className="mb-4 opacity-50" />
                                    <p className="text-lg">Your cart is empty.</p>
                                    <p className="text-sm mt-2 text-muted-foreground">Add some items to get started!</p>
                                </div>
                            ) : (
                                items.map((item) => (
                                    <div key={item.id} className="flex items-center justify-between bg-card p-4 rounded-xl border border-border/50 shadow-sm hover:border-[#199C16]/30 transition-colors">
                                        <div className="flex items-center gap-4">
                                            <div className="bg-card-muted p-3 rounded-lg border border-border w-12 h-12 flex items-center justify-center overflow-hidden">
                                                {item.image ? (
                                                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                                                ) : (
                                                    <Icon icon={item.icon || "mdi:package-variant"} style={{ color: item.color || '#199C16' }} className="text-2xl" />
                                                )}
                                            </div>
                                            <div>
                                                <h4 className="text-foreground font-semibold text-lg">{item.title}</h4>
                                                <p className="text-muted-foreground text-sm font-mono">₦{item.price.toLocaleString()} x {item.quantity}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-5">
                                            <span className="text-foreground font-bold font-mono text-lg">₦{item.totalPrice.toLocaleString()}</span>
                                            <button
                                                onClick={() => dispatch(removeFromCart(item.id))}
                                                className="text-red-500 hover:text-red-400 bg-red-500/10 hover:bg-red-500/20 p-2 rounded-lg transition-colors cursor-pointer"
                                            >
                                                <Icon icon="mdi:trash-can-outline" width="20" />
                                            </button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        <div className="p-6 border-t border-border bg-card z-10 shadow-[0_-10px_30px_rgba(0,0,0,0.5)]">
                            <div className="flex justify-between items-center mb-6">
                                <span className="text-muted-foreground text-lg">Total Amount</span>
                                <span className="text-3xl font-bold text-foreground font-mono">₦{totalAmount.toLocaleString()}</span>
                            </div>
                            {items.length > 0 ? (
                                <PaystackButton
                                    {...componentProps}
                                    className="w-full bg-[#199C16] hover:bg-green-600 text-white py-4 rounded-xl font-bold text-lg transition-all shadow-[0_0_20px_rgba(25,156,22,0.3)] hover:shadow-[0_0_30px_rgba(25,156,22,0.5)] cursor-pointer"
                                />
                            ) : (
                                <button
                                    disabled
                                    className="w-full bg-card-muted text-muted-foreground py-4 rounded-xl font-bold text-lg cursor-not-allowed border border-border"
                                >
                                    Checkout
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default Store;